
import { IAlert, IDataNameFilter, RouterName } from "@/models/common";
import {
  IGetRequestListOptions,
  RequestListType,
  RequestLiveStatuses,
  RequestStatuses,
} from "@/models/request";
import { computed, defineComponent, PropType, reactive, ref, Ref } from "vue";
import RequestCard from "@/components/common/Request/RequestCard.vue";
import DateNameFilter from "@/components/common/DateNameFilter.vue";
import DateFormat from "@/utils/date-format";
import { useI18n } from "vue-i18n";
import { IRequestListItem, RequestKindTypes } from "@/models/request";
import { useStore } from "@/store";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import CancelConfirm from "@/components/common/Confirm/CancelConfirm";
import $API from "@/services";
import router from "@/router";
import { isArray } from "lodash";
import { RouteRecordName } from "vue-router";
import { messageType } from "@/models/message";

export default defineComponent({
  name: "Request Card List",
  props: {
    type: {
      type: Number as PropType<RequestListType>,
      required: true,
    },
    kind: {
      type: String as PropType<RequestKindTypes>,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const isPaySupport = process.env.VUE_APP_IS_PAID === "true" || false;
    console.log(isPaySupport, "isPaySupport");

    const store = useStore();

    const { t } = useI18n({ useScope: "global" });

    const state = reactive({
      list: [] as Array<IRequestListItem>,
      isActive: true,
      type: props.type,
      isMouseOver: false,
      kind: props.kind,
      isVisibleCancel: true,
      isShow: props.isShow,
    });

    const queryNames = {
      from: state.type === RequestListType.Request ? "reqF" : "resF",
      to: state.type === RequestListType.Request ? "reqT" : "resT",
      name: state.type === RequestListType.Request ? "reqN" : "resN",
    };

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    const reqStatusDesc = computed(() => {
      console.log(isPaySupport, "reqStatusDesc.isPaySupport");

      return isPaySupport
        ? [
            state.kind === RequestKindTypes.OnlineCare ? t("Scheduled") : t("check payment"),
            t("requested and wait payid"),
            t("refunded"),
          ]
        : [
            state.kind === RequestKindTypes.OnlineCare ? t("Scheduled") : "",
            t("requested"),
            t("rejected"),
          ];
    });
    const resStatusDesc = computed(() => {
      console.log(isPaySupport, "resStatusDesc.isPaySupport");

      return isPaySupport
        ? [t("responded"), t("refund and reject"), t("canceled")]
        : [t("responded"), t("rejected"), t("canceled")];
    });

    const statusDesc = computed(() =>
      state.type === RequestListType.Request ? reqStatusDesc.value : resStatusDesc.value
    );

    const query = router.currentRoute.value.query;

    console.log("query=>", query);

    const filterState: IDataNameFilter = reactive({
      from:
        !isArray(query[queryNames.from]) && query[queryNames.from]?.toString()
          ? query[queryNames.from]?.toString() ?? DateFormat.getStringSetMonth(-1)
          : DateFormat.getStringSetMonth(-1),
      to:
        !isArray(query[queryNames.to]) && query[queryNames.to]?.toString()
          ? query[queryNames.to]?.toString() ?? DateFormat.getStringNow()
          : DateFormat.getStringNow(),
      name:
        !isArray(query[queryNames.name]) && query[queryNames.name]?.toString()
          ? query[queryNames.name]?.toString() ?? ""
          : "",
    });

    const isRequest = computed(() => state.type === RequestListType.Request);

    const newRequest = computed(() => {
      return {
        name:
          state.kind === RequestKindTypes.OnlineCare
            ? RouterName.ONLINE_CARE_REQUEST_NEW
            : RouterName.SECOND_OPINION_REQUEST_NEW,
      };
    });

    const getReqeustList = async (filterState: IDataNameFilter) => {
      const options: IGetRequestListOptions = {
        RequestKinds: state.kind,
        IsLive: RequestLiveStatuses.Live,
        DateStart: filterState.from.replaceAll("-", ""),
        DateEnd: filterState.to.replaceAll("-", ""),
      };

      const reqItems = await $API.RequestService.getRequestList(options);

      if (reqItems && !Array.isArray(reqItems)) return;
      reqItems.forEach((item) => {
        item.type = RequestListType.Request;
      });
      state.list = [...reqItems];

      if (filterState.name.trim() !== "")
        state.list = state.list.filter(
          (item) =>
            item.ReferredDrName?.includes(filterState.name) ||
            item.DesiredDrName?.includes(filterState.name) ||
            item.DocFacilityName?.includes(filterState.name) ||
            item.DesiredDrDeptName?.includes(filterState.name) ||
            item.ReferredDrDeptName?.includes(filterState.name)
        );
    };

    const add = computed(() => {
      return {
        name:
          state.kind === RequestKindTypes.OnlineCare
            ? RouterName.ONLINE_CARE_REQUEST_NEW
            : RouterName.SECOND_OPINION_REQUEST_NEW,
      };
    });

    const path = reactive({
      add,
    });

    const getResponseList = async (filterState: IDataNameFilter) => {
      const options = {
        DateStart: filterState.from.replaceAll("-", ""),
        DateEnd: filterState.to.replaceAll("-", ""),
        RequestKinds: state.kind,
        IsLive: RequestLiveStatuses.Terminated,
      };

      const reqItems = await $API.RequestService.getRequestList(options);

      if (reqItems && !Array.isArray(reqItems)) return;
      reqItems.forEach((item) => {
        item.type = RequestListType.Response;
      });
      state.list = [...reqItems];
    };

    const getList = async () => {
      try {
        store.commit(CommonMutationTypes.SET_IS_LODING, true);
        if (state.type === RequestListType.Request) await getReqeustList(filterState);
        else if (state.type === RequestListType.Response) await getResponseList(filterState);
      } catch (e) {
        console.error(e);
      } finally {
        store.commit(CommonMutationTypes.SET_IS_LODING, false);
      }
    };

    const filtedList = computed(() => {
      return state.list.filter((item) => {
        if (state.isVisibleCancel || item.RequestStatus !== RequestStatuses.Canceled) return item;
      });
    });

    const CancelAccept = () => router.go(0);

    return {
      state,
      isRequest,
      t,
      newRequest,
      RequestListType,
      filterState,
      getResponseList,
      store,
      CommonMutationTypes,
      path,
      getList,
      filtedList,
      getReqeustList,
      RequestKindTypes,
      statusDesc,
      queryNames,
      alert,
      CancelAccept,
    };
  },
  async mounted() {
    await this.onSearch(this.filterState);
  },
  methods: {
    CancelRequest(requestKey: number) {
      (this.$refs.cancel$ as CancelConfirm).cancelConfirm(requestKey);
    },

    /**
     * Request Cancel button Click Event
     */

    toggleActive() {
      this.state.isActive = !this.state.isActive;
    },

    /**
     * filter Event
     */
    async onSearch(filterState: IDataNameFilter) {
      this.state.list = [];
      if (filterState.name.length > 0 && filterState.name.trim().length < 2) {
        this.alert = {
          title: this.t("enter at least two characters without spaces"),
          content: this.t("search failed"),
          type: messageType.INFO,
        };
      } else {
        try {
          this.store.commit(CommonMutationTypes.SET_IS_LODING, true);
          if (filterState.from === "") filterState.from = DateFormat.getStringSetMonth(-1);
          if (filterState.to === "") filterState.to = DateFormat.getStringNow();
          this.filterState = filterState;

          console.log(" DateFormat.getStringNow()=>",  DateFormat.getStringNow());

          const from = this.queryNames.from;
          const to = this.queryNames.to;
          const name = this.queryNames.name;

          const currentQuery = router.currentRoute.value.query;
          const query: any = { ...currentQuery };
          query[from] = filterState.from;
          query[to] = filterState.to;
          query[name] = filterState.name;

          //필터 검색 주소창에 표시
          this.$router.push({
            name: this.$router.currentRoute.value.name as RouteRecordName,
            query,
          });
          this.state.list = [];

          //따로
          if (this.state.type === RequestListType.Request) await this.getReqeustList(filterState);
          else if (this.state.type === RequestListType.Response)
            await this.getResponseList(filterState);

          //같이
          // await this.getReqeustList(this.filterState);
          // await this.getResponseList(this.filterState);

          // if (this.filterState.name !== "")
          //   this.state.list = this.state.list.filter((item) => {
          //     if (
          //       (item.ReferredDrName ?? item.DesiredDrName ?? "").includes(
          //         this.filterState.name
          //       )
          //     )
          //       return item;
          //   });
        } catch (e) {
          console.error(e);
        } finally {
          this.store.commit(CommonMutationTypes.SET_IS_LODING, false);
        }
      }
    },
  },

  components: {
    RequestCard,
    CancelConfirm,
    DateNameFilter,
  },
});
